import { useUI } from "../store";
import { segmentGroup, segmentOff, segmentOn } from "../ui";

// Converted alongside AppShell rather than with Login, because those two are its
// only consumers — restyling it while AppShell was still light would have made
// it wrong in one of the two places it appears.
export function LanguageSwitch() {
  const { language, setLanguage } = useUI();
  const state = (active: boolean) => `${active ? segmentOn : segmentOff} min-w-[31px] px-[7px] font-mono`;
  return <div className={`${segmentGroup} shrink-0`} role="group" aria-label={language === "th" ? "ภาษา" : "Language"}>
    <button aria-pressed={language === "th"} className={state(language === "th")} onClick={() => setLanguage("th")}>TH</button>
    <button aria-pressed={language === "en"} className={state(language === "en")} onClick={() => setLanguage("en")}>EN</button>
  </div>;
}
